const wsProtocol = {
  'https:': 'wss',
  'http:': 'ws'
};

export const environment = {
  production: true,
  apiUrl: `${location.origin}/api`,
  stompUrl: `${wsProtocol[location.protocol]}://${location.host}/stomp`,
  socketUrl: `${wsProtocol[location.protocol]}://${location.host}`
};
